import React from 'react';
import { Row, Col } from 'antd';
// import './index.css'
import DetailItem from './../../CSIComponents/DetailItem';
interface propsTypes {
    detail: void | any,
}
const ReferenceDetail = (props: propsTypes | any) => {

    const detailData = [
        { label: 'Name', value: props.rowData.name, span: 6 },
        { label: 'ID', value: props.rowData.id, span: 6 },
        { span: 5 },
        { label: 'Direction/Description', value: props.rowData.directiondescription, span: 12 },
        { span: 11 },
        { label: 'Type', value: props.rowData.type, span: 6 },
        { label: '3 Character Airport Code', value: props.rowData.airportcode, span: 6 },
        { span: 5 },
        { label: 'Type Detail', value: props.rowData.typedetail, span: 12 },
        { span: 11 },

        { label: 'Category', value: props.rowData.category, span: 6 },
        { label: 'Distance', value: props.rowData.distance, span: 6 },
        { label: 'Distance Unit', value: props.rowData.distanceunit, span: 6 },
        { span: 5 },

        { label: 'Direction', value: props.rowData.direction, span: 6 },
        { label: 'To or From', value: props.rowData.toorfrom, span: 6 },
        { label: 'Is Nearest', value: props.rowData.isnearest === 'true' ? 'Yes' : (props.rowData.isnearest === 'false' ? 'No' : ''), span: 6 },
        { span: 5 },
        { label: 'Is Primary', value: props.rowData.isprimary === 'true' ? 'Yes' : (props.rowData.isprimary === 'false' ? 'No' : ''), span: 6 },
        { label: 'Latitude', value: props.rowData.latitude, span: 6 },
        { label: 'Longitude', value: props.rowData.longitude, span: 6 },
        { span: 5 },

        { label: 'Geocode Accuracy', value: props.rowData.accuracy, span: 6 },
        { label: 'Country', value: props.rowData.country, span: 6 },
        { label: 'State', value: props.rowData.state, span: 6 },
        { span: 6 },
        { label: 'Rank', value: props.rowData.rank, span: 6 },
        {label: 'Hotel Location', value: props.rowData.hotellocation, span: 6 },
        { span: 6 },
    ]

    return (
        <div style={{ paddingLeft: 16 }}>
            <Row gutter={24}>
                {detailData.map((item, i) => {
                    return (
                        <>
                            {
                                item.label ? <Col span={item.span} key={i} className="col-margin">
                                    <DetailItem value={item.value} label={item.label} />
                                </Col> : <Col span={item.span} key={i}></Col>
                            }
                        </>

                    )
                })
                }
            </Row>
        </div>
    )
}

export default ReferenceDetail;

